import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { RoleInfoDto } from 'app/@types/dto/role-info-dto.model';
import { SecurityRoleDto } from 'app/@types/dto/security-role-dto.model';
import { Observable } from 'rxjs';

import { UrlService } from './url.service';
import { UserInfoDto } from 'app/@types/dto/user-info-dto.model';

export interface IRoleDataSource {
    get(orgId: string): Observable<RoleInfoDto[]>;
    update(orgId: string, input: Partial<SecurityRoleDto[]>): Observable<SecurityRoleDto>;
    delete(orgId: string, userId: string): Observable<RoleInfoDto>;
}

@Injectable({
    providedIn: 'root',
})
export class RoleHttpService implements IRoleDataSource {
    constructor(private http: HttpClient, private urlService: UrlService) {}

    get(orgId: string): Observable<RoleInfoDto[]> {
        return this.http.get<RoleInfoDto[]>(this.urlService.getAndUpdateRoles(orgId));
    }

    // Update a role
    update(orgId: string, input: Partial<SecurityRoleDto[]>): Observable<SecurityRoleDto> {
        return this.http.post<SecurityRoleDto>(this.urlService.getAndUpdateRoles(orgId), input);
    }

    // Delete a role
    delete(orgId: string, userId: string): Observable<RoleInfoDto> {
        return this.http.delete<RoleInfoDto>(this.urlService.deleteRole(orgId, userId));
    }

    updateEntity(orgId: string, roleDto: SecurityRoleDto[]) {
        return this.http.post(this.urlService.updateEntity(orgId), roleDto);
    }
}
